import { default as originalStyled } from 'styled-components';

export const styled = originalStyled;
